module.exports = __webpack_public_path__ + "resources/img/bg-industrytrends-top@2x.ba5dafb1.jpg";